import { ExtendLocales } from 'src/enums'

export type InitialUnauthedLocale =
  | { source: 'query'; locale: ExtendLocales }
  | { source: 'cookie'; locale: ExtendLocales }
  | { source: 'none'; locale: undefined }

export const normalizeExtendLocale = (
  value: unknown,
): ExtendLocales | undefined => {
  const locale = Array.isArray(value) ? value[0] : value
  if (typeof locale !== 'string') return undefined

  const normalizedLocale = (locale.slice(0, -2) +
    locale.slice(-2).toUpperCase()) as ExtendLocales

  return Object.values(ExtendLocales).includes(normalizedLocale)
    ? normalizedLocale
    : undefined
}

export const resolveInitialUnauthedLocale = (
  queryLocale: unknown,
  cookieLocale: unknown,
): InitialUnauthedLocale => {
  const normalizedQueryLocale = normalizeExtendLocale(queryLocale)
  if (normalizedQueryLocale !== undefined) {
    return { source: 'query', locale: normalizedQueryLocale }
  }

  const normalizedCookieLocale = normalizeExtendLocale(cookieLocale)
  if (normalizedCookieLocale !== undefined) {
    return { source: 'cookie', locale: normalizedCookieLocale }
  }

  return { source: 'none', locale: undefined }
}

export const applyInitialUnauthedLocale = (
  initialLocale: InitialUnauthedLocale,
  setLocale: (locale: ExtendLocales) => void,
  persistLocale: (locale: ExtendLocales) => void,
): void => {
  if (initialLocale.locale !== undefined) {
    setLocale(initialLocale.locale)
  }

  if (initialLocale.source === 'query') {
    persistLocale(initialLocale.locale)
  }
}
